import { render, staticRenderFns } from "./ProjectMemberSelect.vue?vue&type=template&id=270f8516"
import script from "./ProjectMemberSelect.vue?vue&type=script&lang=js"
export * from "./ProjectMemberSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports